module.exports = __webpack_public_path__ + "img/picture_gzzm01@2x.f7317912.png";